import { withTheme } from 'styled-components';
import asReduxFormField from '../asReduxFormField';
import { PureSelect } from './BlockSelectField';

export const ReduxFormSelect = asReduxFormField(withTheme(PureSelect));
export const BlockSelectField = withTheme(PureSelect);

export default withTheme(PureSelect);
